<template>
  <div class="mm">
    <br/>
    <p style="text-align: center;font-weight: 800;">
      <span style="font-size:22px;">彩云通车检线上预约系统使用说明</span>
    </p>
    <p style="text-align: center">
      <strong><span style="font-size:20px;">&nbsp;</span></strong>
    </p>
    <p style="text-indent: 37px; text-align: justify; line-height: 2em;margin-top: 10px">
      <span style="font-size:16px;">为进一步方便广大车主进行车辆检车审验，我公司开发的彩云通车检预约系统现已上线运行，车辆检车线上预约业务分为<span style="font-weight: 800">上门代检、到站代检、预约检车</span>三种类型，车型仅限7座及以下客车，相关业务流程操作如下：</span>
    </p>
    <p style="text-indent: 38px;text-align: left; line-height: 2em;font-weight: 800;">
      <span style="font-size: 19px; ;">一、上门代检业务</span>
    </p>
    <p style="text-indent: 38px; text-align: justify; line-height: 2em;">
      <span style="font-size:16px;">上门代检业务是针对没有时间到站检车的客户提供的上门取还车代检车服务。</span>
    </p>
    <p style="text-indent: 38px; text-align: justify; line-height: 2em;">
      <span style="font-size:16px;">温馨提示：办理上门代检车业务需要提前通过彩云通微信公众平台提交上门取车地址、预约检车时间和车辆相关信息。此后，工作人员会在后台对您提交的车辆相关信息完整性和准确性进行审核，审核通过后将会有工作人员与您联系确认上门取车相关事宜。</span>
    </p>
    <p style="text-indent: 38px; text-align: justify; line-height: 2em;">
      <span style="font-size:16px;">车辆检车过程中如出现技术问题无法通过车检的，工作人员将与您联系办理车辆维修及送返事宜，将车辆送返至您指定的地址。如完成检车，车辆将由工作人员送返至指定地址。</span>
    </p>
    <p style="text-indent: 38px; text-align: justify; line-height: 2em;">
      <span style="font-size:16px;">收费标准：线上一次性支付包含（取还车费100元/次，代办检车费100元/次，车辆检测费160元/次）。取还车范围不得超出太和街道、下关街道、大理经济技术开发区、满江街道、凤仪镇等五个行政区域。如超出范围费用需另算。</span>
    </p>
    <p style="text-indent: 38px; text-align: justify; line-height: 2em;">
      <span style="font-size:16px;">退检收费说明：下单后如需退检将收取代检费100元/次10%的退检手续费，取还车费100元/次不退，车辆检测费160元/次全额退款。</span>
    </p>
    <p style="text-align:center">
      <span style="text-align:center;font-size:16px;"><img width="100%" height="100%" src="/lbt/info_1.jpg"/></span>
    </p>
    <p style="text-align:center">
      <span style="font-size:14px;">注：（目前暂仅支持金益检车站车辆代检车服务）</span>
    </p>
    <p style="text-indent: 38px;line-height: 2em;font-weight: 800;">
      <span style="font-size: 16px;">二、到站代检业务</span>
    </p>
    <p style="text-indent: 37px; text-align: justify; line-height: 2em;">
      <span style="font-size:16px;">温馨提示：到站代检业务是为自行驾驶车辆到站检车客户提供的交钥匙式车辆代检车服务。办理到站代检车业务需要提前通过彩云通微信公众平台提交客户信息、预约检车时间和车辆相关信息。工作人员将在后台对您提交的车辆相关信息完整性和准确性进行审核，审核通过后您将收到彩云通发送的审核结果通知以及预约成功的通知。客户根据预约时间将车辆驾驶至报检大厅停车厂与工作人员交接后，即可在休息区等候，车辆将由工作人员驾驶上线检车。</span>
    </p>
    <p style="text-indent: 37px; text-align: justify; line-height: 2em;">
      <span style="font-size:16px;">车辆检车过程中如出现技术问题无法通过车检的，工作人员将与您联系办理车辆维修及送返事宜，完成检车后，车辆将由工作人员送返至报检大厅停车场与您交接。</span>
    </p>
    <p style="text-indent: 37px; text-align: justify; line-height: 2em;">
      <span style="font-size:16px;">收费标准：线上一次性支付包含（代办检车费100元/次，车辆检测费160元/次）。</span>
    </p>
    <p style="text-indent: 37px; text-align: justify; line-height: 2em;">
      <span style="font-size:16px;">退检收费说明：下单后如需退检将收取代检费100元/次10%的退检手续费，车辆检测费160元/次全额退款。</span>
    </p>
    <p style="text-align:center;">
      <span style="text-align:center;font-size:18px;"><img width="100%" height="100%" src="/lbt/info_2.jpg"/></span>
    </p>

    <p style="text-indent: 38px;line-height: 2em;font-weight: 800;">
      <span style="font-size: 16px;">三、预约检车业务</span>
    </p>
    <p style="text-indent: 38px;text-align: justify; line-height: 2em;">
      <span style="font-size:16px;">预约检车业务是针对自行到站检车客户提供的线上预约服务。线上预约到站检车的客户可以在各检车站绿色通道办理相关业务，通过相关信息提前提交和预审核加快检车流程，免除您在窗口排队的烦恼。</span>
    </p>
    <p style="text-align:center">
      <span style="text-align:center;font-size:18px;"><img width="100%" height="100%" src="/lbt/info_3.jpg"/></span>
    </p>
    <p style="text-indent: 38px;text-align: justify; line-height: 2em;">
      <span style="font-size:16px;">办理到站检车预约业务需要提前通过彩云通微信公众平台提交姓名、电话、预约检车时间等信息，以及拟检车车辆行驶证信息、交强险保单照片（可通过拍照行驶证（正照）自动识别录入信息，可省去更多填信息的时间）等车辆相关信息。</span>
    </p>
    <p style="text-align:center">
      <span style="text-align:center;font-size:18px;"><img width="100%" height="100%" src="/lbt/info_4.jpg"/></span>
    </p>
    <p style="text-indent: 38px;text-align: justify; line-height: 2em;">
      <span style="font-size:16px;">此后，工作人员将在后台对您提交的车辆相关信息完整性和准确性进行审核，审核通过后您将收到彩云通发送的审核结果通知以及预约成功的通知。如预约时间检车车辆较多时，检车站工作人员将及时联系车主灵活调整预约检车时间。</span>
    </p>
    <p style="text-indent: 37px; text-align: justify; line-height: 2em;">
      <span style="font-size:16px;">收费标准：线上一次性支付包含（平台预约服务费10元/次，车辆检测费为160元/次）。</span>
    </p>
    <p style="text-indent: 37px; text-align: justify; line-height: 2em;">
      <span style="font-size:16px;">退检收费说明：下单后如需退检将收取平台预约服务费10元，车辆检测费160元/次全额退款。</span>
    </p>
    <p style="text-align:center">
      <span style="text-align:center;font-size:18px;"><img width="100%" height="100%" src="/lbt/info_5.jpg"/></span>
    </p>
    <p style="text-align:center">
      <span style="text-align:center;font-size:18px;"><img width="100%" height="100%" src="/lbt/info_6.jpg"/></span>
    </p>

    <p style="text-align: justify; line-height: 2em;font-weight: 800;">
      <span style="font-size:16px;">检车必备材料及注意事项：</span>
    </p>
    <p style="text-indent: 37px; text-align: justify; line-height: 2em;">
      <span style="font-size:16px;">（1）检车必备材料：机动车行驶证副本原件、本车年度车船税完税凭证或免税证明。</span>
    </p>
    <p style="text-indent: 37px; text-align: justify; line-height: 2em;">
      <span style="font-size:16px;">（2）车检流程：机动车外观预检、提交相关材料（行驶证、保险单、车钥匙）；车辆信息登录报检、车辆上线检车；车辆检车合格完毕后，等待车管所审核签证。</span>
    </p>
    <p style="text-indent: 37px; text-align: justify; line-height: 2em;">
      <span style="font-size:16px;">（3）注意事项：在办理年检前请先处理车辆违章；请按规定配置灭火器和三角警示牌；请保持车况良好、车身、车窗内部、发动机外部清洁；不要将检车手续交于不法中介，维护您的正当权益。车辆检车预约过程中，大理交运客服：400-600-5180、18987212328或检车服务专员李先生18787477662、杨先生18987213668将与您联系车辆检车相关事宜，请注意接听来电。</span>
    </p>
    <p>
      <br/>
    </p>
  </div>
</template>

<script>
export default {
  name: "info"
}
</script>

<style scoped>
  .mm{
    margin: 8px;
  }
</style>
